// @flow
import React from 'react';
import { connect } from 'react-redux';
import { assign } from 'lodash';
import { NotificationStack } from 'react-notification';
import { removeNotification } from '../modules/actions';



function AnalyticsNotificationStack(props: { notifications: SbiNotification[], onDismiss: string => void }) {
    return (
        <NotificationStack
            barStyleFactory={(index, style, notification) =>
                assign({}, notification.style, { bottom: `${2 + index * 4}rem` })
            }
            notifications={props.notifications}
            onDismiss={el => props.onDismiss(el.key)}
        />
    );
}

function mapStateToProps(state) {
    return {
        notifications: state.notifications
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onDismiss(key) {
            dispatch(removeNotification(key));
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AnalyticsNotificationStack);



// WEBPACK FOOTER //
// ./containers/AnalyticsNotificationStack.jsx